import * as G6 from '@antv/g6';
import { difference } from 'lodash/fp';

import Behavior, {
  CanvasSelectablesSelectionBehavior,
} from 'dashboard/components/GraphCanvasV2/behaviors';
import CameraPanBehavior from 'dashboard/components/GraphCanvasV2/behaviors/camera-pan-behavior';
import CameraSelectBehavior from 'dashboard/components/GraphCanvasV2/behaviors/camera-select-behavior';
import CanvasMouseTrackerBehavior from 'dashboard/components/GraphCanvasV2/behaviors/canvas-mouse-tracker-behavior';
import CanvasSelectablesDragBehavior from 'dashboard/components/GraphCanvasV2/behaviors/canvas-selectables-drag-behavior';
import CanvasSelectablesSelectionPanBehavior from 'dashboard/components/GraphCanvasV2/behaviors/canvas-selectables-selection-pan-behavior';
import HoverCardBehavior from 'dashboard/components/GraphCanvasV2/behaviors/hover-card-behavior';
import Mode from 'dashboard/components/GraphCanvasV2/behaviors/mode';
import Layers from 'dashboard/components/GraphCanvasV2/event-bus/layers';
import WheelLayers from 'dashboard/components/GraphCanvasV2/event-bus/wheel-layers';
import CanvasClickEvent from 'dashboard/components/GraphCanvasV2/events/canvas-click-event';
import CanvasMouseDownEvent from 'dashboard/components/GraphCanvasV2/events/canvas-mouse-down-event';
import CanvasMouseEnterEvent from 'dashboard/components/GraphCanvasV2/events/canvas-mouse-enter-event';
import CanvasMouseLeaveEvent from 'dashboard/components/GraphCanvasV2/events/canvas-mouse-leave-event';
import CanvasMouseMoveEvent from 'dashboard/components/GraphCanvasV2/events/canvas-mouse-move-event';
import CanvasMouseUpEvent from 'dashboard/components/GraphCanvasV2/events/canvas-mouse-up-event';
import CanvasRightMouseDownEvent from 'dashboard/components/GraphCanvasV2/events/canvas-right-mouse-down-event';
import CanvasRightMouseUpEvent from 'dashboard/components/GraphCanvasV2/events/canvas-right-mouse-up-event';
import CanvasViewportChangeEvent from 'dashboard/components/GraphCanvasV2/events/canvas-viewport-change-event';
import CanvasWheelEvent from 'dashboard/components/GraphCanvasV2/events/canvas-wheel-event';
import CollapsedPairwiseNodeMouseEnterEvent from 'dashboard/components/GraphCanvasV2/events/collapsed-pairwise-node-mouse-enter-event';
import CollapsedPairwiseNodeMouseLeaveEvent from 'dashboard/components/GraphCanvasV2/events/collapsed-pairwise-node-mouse-leave-event';
import GraphDataChangeEvent from 'dashboard/components/GraphCanvasV2/events/graph-data-change-event';
import GraphEvent from 'dashboard/components/GraphCanvasV2/events/graph-event';
import HoverCardMouseEnterEvent from 'dashboard/components/GraphCanvasV2/events/hover-card-mouse-enter-event';
import HoverCardMouseLeaveEvent from 'dashboard/components/GraphCanvasV2/events/hover-card-mouse-leave-event';
import KeyDownEvent from 'dashboard/components/GraphCanvasV2/events/key-down-event';
import KeyUpEvent from 'dashboard/components/GraphCanvasV2/events/key-up-event';
import ModeChangedEvent from 'dashboard/components/GraphCanvasV2/events/mode-changed-event';
import NodeClickEvent from 'dashboard/components/GraphCanvasV2/events/node-click-event';
import NodeMouseDownEvent from 'dashboard/components/GraphCanvasV2/events/node-mouse-down-event';
import NodeMouseEnterEvent from 'dashboard/components/GraphCanvasV2/events/node-mouse-enter-event';
import NodeMouseLeaveEvent from 'dashboard/components/GraphCanvasV2/events/node-mouse-leave-event';
import NodeMouseMoveEvent from 'dashboard/components/GraphCanvasV2/events/node-mouse-move-event';
import NodeMouseUpEvent from 'dashboard/components/GraphCanvasV2/events/node-mouse-up-event';
import NodePositionChangeEvent from 'dashboard/components/GraphCanvasV2/events/node-position-change';
import RendererAfterAnimateEvent from 'dashboard/components/GraphCanvasV2/events/renderer-after-animate-event';
import RendererBeforeAnimateEvent from 'dashboard/components/GraphCanvasV2/events/renderer-before-animate-event';
import RendererBeforeLayoutChangeEvent from 'dashboard/components/GraphCanvasV2/events/renderer-before-layout-change-event';
import RendererLayoutChangeEvent from 'dashboard/components/GraphCanvasV2/events/renderer-layout-change-event';
import RendererPaintEvent from 'dashboard/components/GraphCanvasV2/events/renderer-paint-event';
import SelectionBoxMouseDownEvent from 'dashboard/components/GraphCanvasV2/events/selection-box-mouse-down-event';
import SelectionBoxMouseEnterEvent from 'dashboard/components/GraphCanvasV2/events/selection-box-mouse-enter-event';
import SelectionBoxMouseLeaveEvent from 'dashboard/components/GraphCanvasV2/events/selection-box-mouse-leave-event';
import SelectionBoxMouseMoveEvent from 'dashboard/components/GraphCanvasV2/events/selection-box-mouse-move-event';
import SelectionBoxMouseUpEvent from 'dashboard/components/GraphCanvasV2/events/selection-box-mouse-up-event';
import WindowMouseMoveEvent from 'dashboard/components/GraphCanvasV2/events/window-mouse-move-event';
import WindowMouseUpEvent from 'dashboard/components/GraphCanvasV2/events/window-mouse-up-event';
import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import Target from 'dashboard/components/GraphCanvasV2/target/target';
import { CollapsedGroup, CollapsedPairwiseNode, Node } from 'dashboard/models/graph';
import { GraphExplorer } from 'dashboard/models/graph-explorer';

import CollapsedGroupMouseDownEvent from '../events/collapsed-group-mouse-down-event';
import CollapsedGroupMouseEnterEvent from '../events/collapsed-group-mouse-enter-event';
import CollapsedGroupMouseLeaveEvent from '../events/collapsed-group-mouse-leave-event';
import CollapsedGroupMouseMoveEvent from '../events/collapsed-group-mouse-move-event';
import CollapsedGroupMouseUpEvent from '../events/collapsed-group-mouse-up-event';
import CollapsedGroupPositionChangeEvent from '../events/collapsed-group-position-change';
import CollapsedPairwiseNodeMouseDownEvent from '../events/collapsed-pairwise-node-mouse-down-event';
import CollapsedPairwiseNodeMouseMoveEvent from '../events/collapsed-pairwise-node-mouse-move-event';
import CollapsedPairwiseNodeMouseUpEvent from '../events/collapsed-pairwise-node-mouse-up-event';
import CollapsedPairwiseNodePositionChangeEvent from '../events/collapsed-pairwise-node-position-change';

/* eslint-disable @typescript-eslint/ban-ts-comment, no-console */
// @ts-ignore
window.DEBUG_WINDOW_EVENTS = [];
// @ts-ignore
window.DEBUG_CANVAS_EVENTS = [];
// @ts-ignore
window.DEBUG_ORIGIN_EVENTS = [];
// @ts-ignore
window.DEBUG_WHEEL_EVENTS = [];
// @ts-ignore
window.LIST_ALL_WINDOW_EVENTS = function () {
  for (const key in window) {
    if (/^on/.test(key)) {
      const eventType = key.slice(2);
      console.debug(eventType);
    }
  }
};
// @ts-ignore
window.CANVAS_POSITION = function () {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  console.log(document.querySelector('canvas').getBoundingClientRect());
};
/* eslint-enable @typescript-eslint/ban-ts-comment, no-console */

export default class EventBus extends EventTarget {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private _canvas: HTMLCanvasElement;
  /* eslint-disable @typescript-eslint/ban-ts-comment */
  // @ts-ignore
  private _g6Wrapper: G6Wrapper;
  // @ts-ignore
  private _graph: G6.Graph;
  // @ts-ignore
  private _graphExplorer: GraphExplorer;
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private _window: Window;
  // Whether to suppress Graph user actions while (say) the product is loading.
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private isDisabled: boolean;
  // List of modes that we allow switching between
  private enabledModes: Mode[];
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private currentMode: Mode;
  /* eslint-enable @typescript-eslint/ban-ts-comment */
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private behaviorsByMode: Record<Mode, Behavior[]>;

  // NOTE: This might not be the best way to do this, but essentially,
  // no other mouse down events should register if it is active on a specific
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private mouseDownTarget: Target<unknown>;

  // Toggle Events
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private disableWheelEvents: boolean;

  public initialize(
    g6Wrapper: G6Wrapper,
    window: Window,
    graphExplorer: GraphExplorer,
    disableWheelEvents = false,
  ) {
    this._canvas = g6Wrapper.canvasEl;
    this._g6Wrapper = g6Wrapper;
    this._graph = g6Wrapper.graph;
    this._graphExplorer = graphExplorer;
    this._window = window;
    this.isDisabled = true;
    this.currentMode = this.enabledModes[0] || Mode.SELECT;
    this.disableWheelEvents = disableWheelEvents;

    this.initializeListeners();
    this.initializeBehaviors();
  }

  constructor(enabledModes: Mode[] = [Mode.SELECT, Mode.PAN]) {
    super();

    this.enabledModes = enabledModes;
  }

  // Interface

  public get canvas() {
    return this._canvas;
  }

  public get window() {
    return this._window;
  }

  public get mode() {
    return this.currentMode;
  }

  public setMode(mode: Mode) {
    // must be a valid mode
    if (!this.enabledModes.includes(mode)) {
      return;
    }

    if (this.currentMode !== mode) {
      const currentBehaviors = this.behaviorsByMode[this.currentMode];
      const nextBehaviors = this.behaviorsByMode[mode];
      const removedBehaviors = difference(currentBehaviors, nextBehaviors);
      const addedBehaviors = difference(nextBehaviors, currentBehaviors);

      for (const behavior of removedBehaviors) {
        behavior.reset();
      }

      for (const behavior of addedBehaviors) {
        behavior.reactivate();
      }

      this.currentMode = mode;
      this.dispatchEvent(new ModeChangedEvent(null, this.currentMode));
    }
  }

  public setIsDisabled(isLoading: boolean) {
    this.isDisabled = isLoading;
  }

  // From a point on screen, figure out where the point is on canvas
  public getCanvasPoint(windowX: number, windowY: number): { x: number; y: number } {
    const { left: canvasLeft, top: canvasTop } = this.canvas.getBoundingClientRect();
    /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
    const { left: windowLeft, top: windowTop } = document
      .querySelector('body')
      .getBoundingClientRect();

    const deltaX = canvasLeft - windowLeft;
    const deltaY = canvasTop - windowTop;

    return { x: windowX - deltaX, y: windowY - deltaY };
  }

  public getCanvasBBox() {
    const { top, right, bottom, left } = this.canvas.getBoundingClientRect();
    return { top, right, bottom, left };
  }

  // From a point on screen, figure out where the point is on the graph
  public getWorldPoint(windowX: number, windowY: number): { x: number; y: number } {
    return this._g6Wrapper.getPointByClient(windowX, windowY);
  }

  public destroy() {
    // Capture wheel events
    this._canvas?.removeEventListener('wheel', this.wheelHandler);

    // Capture origin events
    this._window?.removeEventListener('keydown', this.originHandler);
    this._window?.removeEventListener('keypress', this.originHandler);
    this._window?.removeEventListener('keyup', this.originHandler);
    this._window?.removeEventListener('focus', this.originHandler);

    for (const key in this._window) {
      if (/^on/.test(key)) {
        const eventType = key.slice(2);
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        this._window?.removeEventListener(eventType, this.pointerEventHandler);
      }
    }
  }

  // Configuration

  private initializeBehaviors() {
    // Construct singleton behaviors so they're reused across modes.
    const canvasSelectablesSelectionBehavior = new CanvasSelectablesSelectionBehavior(
      this._g6Wrapper,
      this._graphExplorer,
      this,
    );

    const canvasSelectablesSelectionPanBehavior = new CanvasSelectablesSelectionPanBehavior(
      this._g6Wrapper,
      this._graphExplorer,
      this,
    );

    const canvasSelectablesDragBehavior = new CanvasSelectablesDragBehavior(
      this._g6Wrapper,
      this._graphExplorer,
      this,
    );

    const cameraSelectBehavior = new CameraSelectBehavior(
      this._g6Wrapper,
      this._graphExplorer,
      this,
    );
    const cameraPanBehavior = new CameraPanBehavior(this._g6Wrapper, this._graphExplorer, this);
    const hoverCardBehavior = new HoverCardBehavior(this._g6Wrapper, this._graphExplorer, this);
    const canvasMouseTrackerBehavior = new CanvasMouseTrackerBehavior(
      this._g6Wrapper,
      this._graphExplorer,
      this,
    );

    this.behaviorsByMode = {
      [Mode.SELECT]: [
        cameraSelectBehavior,
        hoverCardBehavior,
        canvasSelectablesDragBehavior,
        canvasSelectablesSelectionBehavior,
        canvasMouseTrackerBehavior,
      ],
      [Mode.PAN]: [
        cameraPanBehavior,
        hoverCardBehavior,
        canvasSelectablesSelectionPanBehavior,
        canvasMouseTrackerBehavior,
      ],
    };
  }

  // Internals

  private initializeListeners() {
    // Capture wheel events
    this._canvas.addEventListener('wheel', this.wheelHandler);

    // Capture origin events
    this._window.addEventListener('keydown', this.originHandler);
    this._window.addEventListener('keypress', this.originHandler);
    this._window.addEventListener('keyup', this.originHandler);
    this._window.addEventListener('focus', this.originHandler);

    // Capture other events
    for (const key in this._window) {
      if (/^on/.test(key)) {
        const eventType = key.slice(2);
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        this._window.addEventListener(eventType, this.pointerEventHandler);
      }
    }

    // Initialize GraphEvent listeners
    [
      CanvasClickEvent,
      CanvasMouseDownEvent,
      CanvasMouseMoveEvent,
      CanvasMouseUpEvent,
      CanvasMouseEnterEvent,
      CanvasMouseLeaveEvent,
      CanvasViewportChangeEvent,
      CanvasWheelEvent,
      HoverCardMouseEnterEvent,
      HoverCardMouseLeaveEvent,
      GraphDataChangeEvent,
      KeyDownEvent,
      KeyUpEvent,
      NodeClickEvent,
      NodeMouseDownEvent,
      NodeMouseEnterEvent,
      NodeMouseMoveEvent,
      NodeMouseLeaveEvent,
      NodeMouseUpEvent,
      NodePositionChangeEvent,
      CollapsedGroupMouseDownEvent,
      CollapsedGroupMouseEnterEvent,
      CollapsedGroupMouseMoveEvent,
      CollapsedGroupMouseLeaveEvent,
      CollapsedGroupMouseUpEvent,
      CollapsedGroupPositionChangeEvent,
      CollapsedPairwiseNodeMouseDownEvent,
      CollapsedPairwiseNodeMouseUpEvent,
      CollapsedPairwiseNodeMouseMoveEvent,
      CollapsedPairwiseNodeMouseEnterEvent,
      CollapsedPairwiseNodeMouseLeaveEvent,
      CollapsedPairwiseNodePositionChangeEvent,
      RendererAfterAnimateEvent,
      RendererBeforeAnimateEvent,
      RendererBeforeLayoutChangeEvent,
      RendererLayoutChangeEvent,
      RendererPaintEvent,
      SelectionBoxMouseDownEvent,
      SelectionBoxMouseEnterEvent,
      SelectionBoxMouseLeaveEvent,
      SelectionBoxMouseMoveEvent,
      SelectionBoxMouseUpEvent,
      WindowMouseMoveEvent,
      WindowMouseUpEvent,
    ].forEach((event) => {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      this.addEventListener(event.type, this.graphEventHandler);
    });
  }

  private graphEventHandler(e: GraphEvent<Event>) {
    // Do nothing if we've disabled the event bus.
    if (this.isDisabled) {
      return;
    }

    switch (e.type) {
      case CanvasViewportChangeEvent.type:
      case KeyDownEvent.type:
      case KeyUpEvent.type:
      case RendererAfterAnimateEvent.type:
      case RendererBeforeAnimateEvent.type:
      case RendererBeforeLayoutChangeEvent.type:
      case RendererLayoutChangeEvent.type:
      case RendererPaintEvent.type:
        // Send these events to every behavior that responds to them
        this.behaviorsByMode[this.currentMode].forEach((behavior: Behavior) => {
          if (behavior.respondsToEvent(e)) {
            behavior.callHandler(e);
          }
        });
        break;
      default:
        // Only send events to the first registered behavior that responds
        // to it.
        this.behaviorsByMode[this.currentMode].every((behavior: Behavior) => {
          if (behavior.respondsToEvent(e)) {
            /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
            return !behavior.callHandler(e);
          }

          return true;
        });
    }
  }

  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  private mouseOverTarget: Target<unknown> = null;
  private pointerEventHandler = (e: MouseEvent) => {
    /* eslint-disable @typescript-eslint/ban-ts-comment, no-console */
    // @ts-ignore
    if (window.DEBUG_WINDOW_EVENTS.includes(e.type)) {
      console.groupCollapsed(
        '%cwindow ' + `%c${e.type}`,
        'color:purple;font-weight:bold;',
        'color:blue',
      );
      console.log(e);
      console.groupEnd();
    }

    if (e.type === 'wheel') {
      for (const target of this.makeWheelEventHandlerIterator(e, e.x, e.y)) {
        if (target?.type === 'canvas' && !this.disableWheelEvents) {
          this.dispatchEvent(new CanvasWheelEvent(e as WheelEvent, this.canvas));
          e.stopImmediatePropagation();
          return;
        }

        break;
      }
    }

    // track which element the mouse is on top of;
    // if the element changes, trigger mouseenter/mouseleave.

    for (const target of this.makeClickEventHandlerIterator(e, e.x, e.y)) {
      // The mouse is moving over a new target differing from the last recorded mouseOverTarget.
      if (e.type === 'mousemove') {
        // Note: Always process XLeave events from layer X before YEnter events to layer Y
        // in order to dispatch events (and potentially alter any global context) in the right
        // logical order. Also, Leave events should still use their old target; Enter events want the
        // new target.
        if (target.value !== this.mouseOverTarget?.value) {
          switch (this.mouseOverTarget?.type) {
            case 'hover-card':
              this.dispatchEvent(
                new HoverCardMouseLeaveEvent(e, this.mouseOverTarget.value as HTMLDivElement),
              );
              break;
            case 'node':
              this.dispatchEvent(new NodeMouseLeaveEvent(e, this.mouseOverTarget.value as Node));
              break;
            case 'collapsed-group':
              this.dispatchEvent(
                new CollapsedGroupMouseLeaveEvent(e, this.mouseOverTarget.value as CollapsedGroup),
              );
              break;
            case 'collapsed-pairwise-node':
              this.dispatchEvent(
                new CollapsedPairwiseNodeMouseLeaveEvent(
                  e,
                  this.mouseOverTarget.value as CollapsedPairwiseNode,
                ),
              );
              break;
            case 'selection-box':
              this.dispatchEvent(
                new SelectionBoxMouseLeaveEvent(e, this.mouseOverTarget.value as HTMLDivElement),
              );
              break;
            case 'canvas':
              this.dispatchEvent(
                new CanvasMouseLeaveEvent(e, this.mouseOverTarget.value as HTMLDivElement),
              );
              break;
            default:
              break;
          }

          switch (target.type) {
            case 'hover-card':
              this.dispatchEvent(new HoverCardMouseEnterEvent(e, target.value));
              break;
            case 'node':
              this.dispatchEvent(new NodeMouseEnterEvent(e, target.value));
              break;
            case 'collapsed-group':
              this.dispatchEvent(new CollapsedGroupMouseEnterEvent(e, target.value));
              break;
            case 'collapsed-pairwise-node':
              this.dispatchEvent(new CollapsedPairwiseNodeMouseEnterEvent(e, target.value));
              break;
            case 'selection-box':
              this.dispatchEvent(new SelectionBoxMouseEnterEvent(e, target.value));
              break;
            case 'canvas':
              this.dispatchEvent(new CanvasMouseEnterEvent(e, target.value));
              break;
            default:
              break;
          }

          this.mouseOverTarget = target;
        }

        if (target.type === 'node') {
          // NOTE: Technically this is any mouse move event over a node.
          this.dispatchEvent(new NodeMouseMoveEvent(e, target.value));
        }
        if (target.type === 'collapsed-group') {
          this.dispatchEvent(new CollapsedGroupMouseMoveEvent(e, target.value));
        }
        if (target.type === 'collapsed-pairwise-node') {
          this.dispatchEvent(new CollapsedPairwiseNodeMouseMoveEvent(e, target.value));
        }
      }

      switch (target.type) {
        case 'query-editor': {
          // don't handle anything in the query editor
          break;
        }
        case 'list-view': {
          // don't handle anything in list views
          break;
        }
        case 'hover-card': {
          // don't handle anything in the hover card
          break;
        }
        case 'action-bar': {
          // don't handle anything in the action bar
          break;
        }
        case 'selection-box': {
          if (e.type === 'mousedown') {
            if (e.button === 0) {
              this.dispatchEvent(new SelectionBoxMouseDownEvent(e, target.value));
            }
          }
          if (e.type === 'mousemove') {
            this.dispatchEvent(new SelectionBoxMouseMoveEvent(e, target.value));
          }
          if (e.type === 'mouseup') {
            if (e.button === 0) {
              this.dispatchEvent(new SelectionBoxMouseUpEvent(e, target.value));
            }
          }
          break;
        }
        case 'node': {
          if (e.type === 'click') {
            this.dispatchEvent(new NodeClickEvent(e, target.value));
          }
          if (e.type === 'mousedown') {
            if (e.button === 0) {
              this.dispatchEvent(new NodeMouseDownEvent(e, target.value));
            }
          }
          if (e.type === 'mouseup') {
            if (e.button === 0) {
              this.dispatchEvent(new NodeMouseUpEvent(e, target.value));
            }
          }
          break;
        }
        case 'collapsed-group': {
          if (e.type === 'mousedown') {
            if (e.button === 0) {
              this.dispatchEvent(new CollapsedGroupMouseDownEvent(e, target.value));
            }
          }
          if (e.type === 'mouseup') {
            if (e.button === 0) {
              this.dispatchEvent(new CollapsedGroupMouseUpEvent(e, target.value));
            }
          }
          break;
        }
        case 'collapsed-pairwise-node': {
          if (e.type === 'mousedown') {
            if (e.button === 0) {
              this.dispatchEvent(new CollapsedPairwiseNodeMouseDownEvent(e, target.value));
            }
          }
          if (e.type === 'mouseup') {
            if (e.button === 0) {
              this.dispatchEvent(new CollapsedPairwiseNodeMouseUpEvent(e, target.value));
            }
          }
          break;
        }
        case 'canvas': {
          if (e.type === 'click') {
            this.dispatchEvent(new CanvasClickEvent(e, target.value));
          }
          if (e.type === 'mousedown') {
            if (e.button === 0) {
              this.dispatchEvent(new CanvasMouseDownEvent(e, target.value));
            } else {
              this.dispatchEvent(new CanvasRightMouseDownEvent(e, target.value));
            }
          }
          if (e.type === 'mousemove') {
            this.dispatchEvent(new CanvasMouseMoveEvent(e, target.value));
          }
          if (e.type === 'mouseup') {
            if (e.button === 0) {
              this.dispatchEvent(new CanvasMouseUpEvent(e, target.value));
            } else {
              this.dispatchEvent(new CanvasRightMouseUpEvent(e, target.value));
            }
          }
          break;
        }
        case 'window': {
          if (e.type === 'mousemove') {
            this.dispatchEvent(new WindowMouseMoveEvent(e, target.value));
          }
          if (e.type === 'mouseup') {
            this.dispatchEvent(new WindowMouseUpEvent(e, target.value));
          }
          break;
        }
      }
      // BREAK after first target for now. Eventually, handle propagation
      // control and allow target propagation unless explicitly stopped.
      break;
    }
  };

  private getLayers(x: number, y: number): Layers {
    const { x: canvasX, y: canvasY } = this.getCanvasPoint(x, y);
    return new Layers(
      this._g6Wrapper,
      this._graphExplorer,
      x,
      y,
      canvasX,
      canvasY,
      this.getCanvasBBox(),
    );
  }

  private *makeClickEventHandlerIterator(e: Event, x: number, y: number) {
    // HACK: Find a better way to track state of mousemove and mouseup events
    if (e.type === 'mousemove') {
      if (this.mouseDownTarget) {
        yield this.mouseDownTarget;
      }
    }

    if (e.type === 'mouseup') {
      if (this.mouseDownTarget) {
        const target = this.mouseDownTarget;
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        this.mouseDownTarget = null;
        yield target;
      }
    }

    for (const layer of this.getLayers(x, y)) {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      for (const target of layer) {
        if (e.type === 'mousedown') {
          if (!this.mouseDownTarget) {
            this.mouseDownTarget = target;
          }
        }
        yield target;
      }
    }
  }

  private getWheelLayers(x: number, y: number): Layers {
    const { x: canvasX, y: canvasY } = this.getCanvasPoint(x, y);
    return new WheelLayers(
      this._g6Wrapper,
      this._graphExplorer,
      x,
      y,
      canvasX,
      canvasY,
      this.getCanvasBBox(),
    );
  }

  private *makeWheelEventHandlerIterator(_e: Event, x: number, y: number) {
    for (const layer of this.getWheelLayers(x, y)) {
      /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
      for (const target of layer) {
        yield target;
      }
    }
  }

  private originHandler = (e: Event) => {
    // Do nothing if we've disabled the event bus.
    if (this.isDisabled) {
      return;
    }

    /* eslint-disable @typescript-eslint/ban-ts-comment, no-console */
    // @ts-ignore
    if (window.DEBUG_ORIGIN_EVENTS.includes(e.type)) {
      console.groupCollapsed(
        '%corigin ' + `%c${e.type}`,
        'color:orange;font-weight:bold;',
        'color:blue',
      );
      console.log(e);
      console.groupEnd();
    }
    /* eslint-enable @typescript-eslint/ban-ts-comment, no-console */

    switch (e.type) {
      case 'keydown': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        this.dispatchEvent(new KeyDownEvent(e as KeyboardEvent, null));
        break;
      }
      case 'keyup': {
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        this.dispatchEvent(new KeyUpEvent(e as KeyboardEvent, null));
        break;
      }
    }
  };

  private wheelHandler = (e: WheelEvent) => {
    // Do nothing if we've disabled the event bus.
    if (this.isDisabled) {
      return;
    }

    /* eslint-disable @typescript-eslint/ban-ts-comment, no-console */
    // @ts-ignore
    if (window.DEBUG_WHEEL_EVENTS.includes(e.type)) {
      console.groupCollapsed(
        '%cwheel ' + `%c${e.type}`,
        'color:green;font-weight:bold;',
        'color:blue',
      );
      console.log(e);
      console.groupEnd();
    }

    if (e.ctrlKey) {
      // Stop default browser pinch-to-zoom behavior
      e.preventDefault();
    }

    /* eslint-enable @typescript-eslint/ban-ts-comment, no-console */
    this.graphEventHandler(e as unknown as GraphEvent<Event>);
  };
}
